import React from 'react';
import ReactDOM from 'react-dom/client';
import './style/index.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { NextUIProvider } from "@nextui-org/react";
import ErrorBoundary from './components/ErrorBoundary';
import { initErrorReporting } from './helpers/reportError';

initErrorReporting();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <NextUIProvider>
      <main className={"dark"}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </main>
    </NextUIProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
